import styles from './FAQSection.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class FAQSection extends CustomComponent {
    constructor() {
        super();
        this.customStyle = styles;
    }

    get variant(): string {
        return this.dataset.variant ?? 'vertical';
    }

    render() {
        const container = document.createElement('div');
        container.classList.add(`base-grid`, `variant-${this.variant}`);
        container.innerHTML = `
            <div class="overline"></div>
            <div class="title"></div>
            <div class="content">
                <slot></slot>
            </div>
      `;
        // Clone Slots into container to prevent styling issues
        this.cloneSlotContentIntoContainer(container.querySelector('.overline'), 'overline');
        this.cloneSlotContentIntoContainer(container.querySelector('.title'), 'title');
        return container;
    }

}

customElements.define('nxt-faq-section', FAQSection);
